import React, { useEffect } from "react";
import { SelectInput } from "react-admin";
import { useField } from "react-final-form";
import { vehicleSize } from "../../const";

interface IVehicleSizeInput {
  record: any;
  parentSource: string;
}

const VehicleSizeInput = ({ record, parentSource }: IVehicleSizeInput) => {
  const {
    input: { onChange },
  } = useField(`${parentSource}.vehicleSize`);

  useEffect(() => {
    if (record) {
      if (record.vehicleSize) {
        onChange(record.vehicleSize);
      }
    }
  }, [record]);

  return (
    <SelectInput
      label="Vehicle Size *"
      source={`${parentSource}.vehicleSize`}
      choices={vehicleSize}
    />
  );
};

export default VehicleSizeInput;
